export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  DateTime: any;
  Upload: any;
  Date: any;
};

export type Query = {
  __typename?: "Query";
  debugInfo?: Maybe<DebugInfo>;
  findCompany?: Maybe<CompanyConnection>;
  findUser?: Maybe<UserConnection>;
  getAttributes?: Maybe<AttributeConnection>;
  getBulletinInboxes?: Maybe<BulletinInboxConnection>;
  getBulletins?: Maybe<BulletinConnection>;
  getChannel?: Maybe<Channel>;
  getChannels?: Maybe<ChannelConnection>;
  getDecks?: Maybe<DeckConnection>;
  getEmptyDashboardLinks?: Maybe<EmptyDashboardLinkConnection>;
  getHashtags?: Maybe<HashtagConnection>;
  getIntegration?: Maybe<Integration>;
  getIntegrations?: Maybe<IntegrationConnection>;
  getMessages?: Maybe<MessageConnection>;
  getPrimaryReactionTypes?: Maybe<ReactionTypeConnection>;
  getReactionTypes?: Maybe<ReactionTypeConnection>;
  health?: Maybe<Health>;
  me?: Maybe<User>;
  node?: Maybe<Node>;
  unreadMessages?: Maybe<MessageConnection>;
};

export type QueryFindCompanyArgs = {
  before?: InputMaybe<Scalars["String"]>;
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["ID"]>;
  filter: CompanyFilter;
};

export type QueryFindUserArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  filter?: InputMaybe<UserFilter>;
};

export type QueryGetAttributesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AttributeFilter>;
};

export type QueryGetBulletinInboxesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  filter?: InputMaybe<BulletinInboxFilter>;
};

export type QueryGetBulletinsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BulletinFilters>;
};

export type QueryGetChannelArgs = {
  filter?: InputMaybe<ChannelFilter>;
};

export type QueryGetChannelsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ChannelsFilter>;
};

export type QueryGetDecksArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<DeckFilter>;
};

export type QueryGetEmptyDashboardLinksArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type QueryGetHashtagsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HashtagFilters>;
};

export type QueryGetIntegrationArgs = {
  id: Scalars["ID"];
};

export type QueryGetIntegrationsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<IntegrationFilter>;
};

export type QueryGetMessagesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<GetMessagesFilter>;
};

export type QueryGetPrimaryReactionTypesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type QueryGetReactionTypesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type QueryNodeArgs = {
  id: Scalars["ID"];
};

export type DebugInfo = {
  __typename?: "DebugInfo";
  deviceId?: Maybe<Scalars["String"]>;
  pushToken?: Maybe<Scalars["String"]>;
  subscribedTopics?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CompanyFilter = {
  name__contains?: InputMaybe<Scalars["String"]>;
  name__startswith?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug__contains?: InputMaybe<Scalars["String"]>;
  slug__startswith?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type CompanyConnection = {
  __typename?: "CompanyConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<CompanyEdge>>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  startCursor: Scalars["String"];
  endCursor: Scalars["String"];
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
};

export type CompanyEdge = {
  __typename?: "CompanyEdge";
  node: Company;
  cursor: Scalars["String"];
};

export type Company = Node & {
  __typename?: "Company";
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
  supportURL?: Maybe<Scalars["String"]>;
  mention?: Maybe<CompanyMention>;
  employees?: Maybe<UserConnection>;
  admin?: Maybe<UserConnection>;
  offDuty?: Maybe<Scalars["Boolean"]>;
  offDutyDismiss?: Maybe<Scalars["Boolean"]>;
  inAppCall?: Maybe<Scalars["Boolean"]>;
};

export type CompanyEmployeesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type CompanyAdminArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type Node = {
  id: Scalars["ID"];
};

export enum CompanyMention {
  DisplayTitle = "DISPLAY_TITLE",
  Username = "USERNAME",
}

export type UserConnection = {
  __typename?: "UserConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<UserEdge>>;
  total?: Maybe<Scalars["Int"]>;
};

export type UserEdge = {
  __typename?: "UserEdge";
  node: User;
  cursor: Scalars["String"];
};

export type User = Node & {
  __typename?: "User";
  id: Scalars["ID"];
  username: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  fullName: Scalars["String"];
  displayName: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  isAnonymous?: Maybe<Scalars["Boolean"]>;
  isBot: Scalars["Boolean"];
  company?: Maybe<Company>;
  companies?: Maybe<CompanyConnection>;
  pushTokens?: Maybe<PushTokenConnection>;
  avatar?: Maybe<UserAvatar>;
  jobTitle?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  offDuty: Scalars["Boolean"];
  extendNotifications?: Maybe<ExtendNotifications>;
  /** Only `true` for users who are capable of administration actions */
  isStaff: Scalars["Boolean"];
  /** Only `true` for users who are Rodio employees */
  isSuperuser: Scalars["Boolean"];
  /**
   * Arbitrary key/value data associated with a User
   *
   * Data within this field is a JSON type and is treated like a key/value store
   * associated with the user. This is meant as a method for external integrations
   * to store data. As such, no guarantees are made for the contents of the data.
   *
   * When modifying metadata, you must provide a `key` and a `value`. The returned
   * `User` object will have that value inside this field. For example, if you set
   * the `hris` key to equal `{"id": 123}` you would get a `User` back with the
   * following `metadata`:
   *
   * ```json
   * {
   *   "hris": {
   *     "id": 123
   *   }
   * }
   * ```
   */
  metadata?: Maybe<Scalars["JSON"]>;
  /**
   * Specifies whether the User requesting this can send messages to this User.
   *
   * Note: This is currently only available when querying via `Channel.members`.
   * All other queries that return User will end up with a null value. Please contact
   * the Field Connector team if you need canMessage in another context.
   */
  canMessage?: Maybe<Scalars["Boolean"]>;
  /** Feature flags for this user */
  featureFlags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  attributes?: Maybe<AttributeConnection>;
};

export type UserCompaniesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type UserAttributesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AttributeFilter>;
};

export type PushTokenConnection = {
  __typename?: "PushTokenConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<PushTokenEdge>>;
};

export type PushTokenEdge = {
  __typename?: "PushTokenEdge";
  node: PushToken;
  cursor: Scalars["String"];
};

export type PushToken = {
  __typename?: "PushToken";
  value: Scalars["String"];
  deviceId: Scalars["String"];
  user: User;
};

export type UserAvatar = {
  __typename?: "UserAvatar";
  name: Scalars["String"];
  type: Scalars["String"];
  data: Scalars["String"];
  dimensions?: Maybe<UserAvatarDimensions>;
  size?: Maybe<Scalars["Int"]>;
  url: Scalars["String"];
};

export type UserAvatarDimensions = {
  __typename?: "UserAvatarDimensions";
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
};

export type ExtendNotifications = {
  __typename?: "ExtendNotifications";
  hours?: Maybe<Scalars["Int"]>;
  startTime?: Maybe<Scalars["String"]>;
  endTime?: Maybe<Scalars["String"]>;
};

export type AttributeFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
};

export type AttributeConnection = {
  __typename?: "AttributeConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<AttributeEdge>>;
};

export type AttributeEdge = {
  __typename?: "AttributeEdge";
  cursor: Scalars["String"];
  node: Attribute;
};

export type Attribute = {
  __typename?: "Attribute";
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  company: Company;
  users: UserConnection;
};

export type UserFilter = {
  /**
   * User's `id` field.
   *
   * Note: If `id` is present, all other fields are ignored.
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Dot-separated key/value search.
   *
   * Example: If you're looking for a user that has the following metadata:
   *
   * ```json
   * {
   *   "hris": {
   *     "id": 123
   *   }
   * }
   * ```
   *
   * Use the following metadata query to search:
   *
   * ```json
   * {"hris.id": 123}
   * ```
   *
   * Fields _must_ be exact matches.
   */
  metadata?: InputMaybe<Scalars["JSON"]>;
  /**
   * Opaque search string that's searches the `User`
   *
   * Note, there are no guarantees on what this will search as that's considered
   * an implementation detail. Currently, it searches the following fields:
   *
   * - `firstName`
   * - `lastName`
   * - `username`
   * - `email` – only searched if query contains an "@" symbol
   */
  query?: InputMaybe<Scalars["String"]>;
};

export type BulletinInboxFilter = {
  name?: InputMaybe<Scalars["String"]>;
  name__contains?: InputMaybe<Scalars["String"]>;
};

export type BulletinInboxConnection = {
  __typename?: "BulletinInboxConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<BulletinInboxEdge>>;
};

export type BulletinInboxEdge = {
  __typename?: "BulletinInboxEdge";
  node: BulletinInbox;
  cursor: Scalars["String"];
};

export type BulletinInbox = {
  __typename?: "BulletinInbox";
  id: Scalars["ID"];
  name: Scalars["String"];
  bulletins: BulletinConnection;
  members: UserConnection;
};

export type BulletinInboxBulletinsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type BulletinInboxMembersArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<UserFilter>;
};

export type BulletinConnection = {
  __typename?: "BulletinConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<BulletinEdge>>;
};

export type BulletinEdge = {
  __typename?: "BulletinEdge";
  node: Bulletin;
  cursor: Scalars["String"];
};

export type Bulletin = Node & {
  __typename?: "Bulletin";
  id: Scalars["ID"];
  name: Scalars["String"];
  content: Scalars["String"];
  creator: User;
  createdAt: Scalars["String"];
  expires?: Maybe<Scalars["String"]>;
  publishedAt?: Maybe<Scalars["String"]>;
  scheduledAt?: Maybe<Scalars["String"]>;
  isScheduled?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<BulletinStatus>;
  isPriority: Scalars["Boolean"];
  isRequired: Scalars["Boolean"];
  allowComments: Scalars["Boolean"];
  allowVisibility: Scalars["Boolean"];
  numberOfRecipients?: Maybe<Scalars["Int"]>;
  readRate?: Maybe<Scalars["String"]>;
  viewedRate?: Maybe<Scalars["String"]>;
  expiredRate?: Maybe<Scalars["String"]>;
  via?: Maybe<BulletinInbox>;
  isDraft: Scalars["Boolean"];
  lastEditedTimestamp?: Maybe<Scalars["String"]>;
  recipientInboxes?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  /**
   * List of recipients of this bulletin.
   *
   * Note: This is subject to `allowVisibility` and other permissions as configured
   * by the company. The `creator` of a Bulletin can always see this information, but
   * other users may not be able to.
   */
  recipients?: Maybe<BulletinRecipientConnection>;
  attachments?: Maybe<AttachmentConnection>;
  comments?: Maybe<CommentConnection>;
  hashtags?: Maybe<HashtagConnection>;
};

export type BulletinRecipientsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<UserFilter>;
};

export type BulletinCommentsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type BulletinHashtagsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HashtagFilters>;
};

export enum BulletinStatus {
  Unread = "UNREAD",
  Sent = "SENT",
  Read = "READ",
  Viewed = "VIEWED",
  Expired = "EXPIRED",
}

export type BulletinRecipientConnection = {
  __typename?: "BulletinRecipientConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<BulletinRecipientEdge>>;
};

export type BulletinRecipientEdge = {
  __typename?: "BulletinRecipientEdge";
  node: BulletinRecipient;
  cursor: Scalars["String"];
};

export type BulletinRecipient = Node & {
  __typename?: "BulletinRecipient";
  id: Scalars["ID"];
  bulletin: Bulletin;
  user: User;
  via: BulletinInbox;
  read: Scalars["Boolean"];
  viewed: Scalars["Boolean"];
  updatedAt: Scalars["String"];
  createdAt: Scalars["String"];
};

export type AttachmentConnection = {
  __typename?: "AttachmentConnection";
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<AttachmentEdge>>>;
};

export type AttachmentEdge = {
  __typename?: "AttachmentEdge";
  node: Attachment;
  cursor: Scalars["String"];
};

export type Attachment = {
  id: Scalars["ID"];
  url: Scalars["String"];
};

export type CommentConnection = {
  __typename?: "CommentConnection";
  pageInfo?: Maybe<PageInfo>;
  edges: Array<Maybe<CommentEdge>>;
};

export type CommentEdge = {
  __typename?: "CommentEdge";
  cursor: Scalars["String"];
  node: Comment;
};

export type Comment = Node & {
  __typename?: "Comment";
  id: Scalars["ID"];
  creator: User;
  createdAt: Scalars["String"];
  content: Scalars["String"];
  repliesTo?: Maybe<Node>;
};

export type HashtagFilters = {
  id?: InputMaybe<Scalars["ID"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  query?: InputMaybe<Scalars["String"]>;
  promoted?: InputMaybe<Scalars["Boolean"]>;
};

export type HashtagConnection = {
  __typename?: "HashtagConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<HashtagEdge>>;
};

export type HashtagEdge = {
  __typename?: "HashtagEdge";
  node: Hashtag;
  cursor: Scalars["String"];
};

export type Hashtag = Node & {
  __typename?: "Hashtag";
  id: Scalars["ID"];
  name: Scalars["String"];
  color?: Maybe<HashtagColor>;
  promoted: Scalars["Boolean"];
  messageCount?: Maybe<Scalars["Int"]>;
  bulletinCount?: Maybe<Scalars["Int"]>;
};

export type HashtagColor = Node & {
  __typename?: "HashtagColor";
  id: Scalars["ID"];
  color: Scalars["String"];
  order?: Maybe<Scalars["Int"]>;
};

export type BulletinFilters = {
  status?: InputMaybe<BulletinStatus>;
  hashtags?: InputMaybe<HashtagFilters>;
  isExpired?: InputMaybe<Scalars["Boolean"]>;
  isPriority?: InputMaybe<Scalars["Boolean"]>;
  isRequired?: InputMaybe<Scalars["Boolean"]>;
  isScheduled?: InputMaybe<Scalars["Boolean"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]>;
};

export type ChannelFilter = {
  id?: InputMaybe<Scalars["ID"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type Channel = Node & {
  __typename?: "Channel";
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
  isDirect?: Maybe<Scalars["Boolean"]>;
  isGroup?: Maybe<Scalars["Boolean"]>;
  isMutedByUser?: Maybe<Scalars["Boolean"]>;
  isArchived?: Maybe<Scalars["Boolean"]>;
  /**
   * Date/time of the latest message in the channel
   *
   * Note: Empty channels have this set to their creation time.
   */
  latestMessageAt?: Maybe<Scalars["String"]>;
  lastMessageContent?: Maybe<Scalars["String"]>;
  unreadCount?: Maybe<Scalars["Int"]>;
  /**
   * Number of matching Messages that match within a Channel
   *
   * Note: This field is only present when `search` is used within
   * the `ChannelFilter` object.
   */
  matches?: Maybe<Scalars["Int"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  members?: Maybe<UserConnection>;
  messages?: Maybe<MessageConnection>;
  hashtags?: Maybe<HashtagConnection>;
};

export type ChannelMembersArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<UserFilter>;
};

export type ChannelMessagesArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
};

export type ChannelHashtagsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HashtagFilters>;
};

export type MessageConnection = {
  __typename?: "MessageConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<MessageEdge>>;
};

export type MessageEdge = {
  __typename?: "MessageEdge";
  node: Message;
  cursor: Scalars["String"];
};

export type Message = Node & {
  __typename?: "Message";
  id: Scalars["ID"];
  creator: User;
  content: Scalars["String"];
  read?: Maybe<Scalars["Boolean"]>;
  channel: Channel;
  reactions?: Maybe<ReactionConnection>;
  is_system_message?: Maybe<Scalars["Boolean"]>;
  createdAt: Scalars["String"];
  /** This flag is always true when sent from GraphQL. It provides a flag for UIs to know whether their copy is local or not. */
  fromServer: Scalars["Boolean"];
  /**
   * Optional field that contains highlighted "headline" for search result
   *
   * This is only present on queries that use `search` parameter when filtering
   * messages. The matching search selection is highlighted with Markdown's
   * bold / emphasis of `**`.
   */
  headline?: Maybe<Scalars["String"]>;
  attachments?: Maybe<AttachmentConnection>;
  hashtags?: Maybe<HashtagConnection>;
};

export type MessageHashtagsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HashtagFilters>;
};

/**
 * Connection of reactions associated with a Message
 *
 * Note: when this is accessed via `Message.reactions` it will always be empty.
 * The empty values are provided for backwards compatability. The main use case
 * is the `summary` field that's provided here.
 *
 * Future versions of the API may provide a means of accessing the underlying
 * connections.
 */
export type ReactionConnection = {
  __typename?: "ReactionConnection";
  pageInfo: PageInfo;
  summary?: Maybe<Array<Maybe<ReactionSummary>>>;
  edges: Array<Maybe<ReactionEdge>>;
};

export type ReactionSummary = {
  __typename?: "ReactionSummary";
  id: Scalars["ID"];
  name: Scalars["String"];
  total: Scalars["Int"];
  messageId: Scalars["ID"];
  userSent: Scalars["Boolean"];
  users: Array<Maybe<User>>;
};

export type ReactionEdge = {
  __typename?: "ReactionEdge";
  node: Reaction;
  cursor: Scalars["String"];
};

export type Reaction = Node & {
  __typename?: "Reaction";
  id: Scalars["ID"];
  creator: User;
  message: Scalars["ID"];
  reaction?: Maybe<ReactionType>;
};

export type ReactionType = Node & {
  __typename?: "ReactionType";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type ChannelsFilter = {
  forUser?: InputMaybe<Scalars["ID"]>;
  type?: InputMaybe<ChannelType>;
  status?: InputMaybe<ChannelStatus>;
  isArchived?: InputMaybe<Scalars["Boolean"]>;
  /** Search for channels that contain Messages matching the search. */
  search?: InputMaybe<Scalars["String"]>;
};

export enum ChannelType {
  Team = "TEAM",
  Direct = "DIRECT",
  Group = "GROUP",
}

export enum ChannelStatus {
  All = "ALL",
  Read = "READ",
  Unread = "UNREAD",
}

export type ChannelConnection = {
  __typename?: "ChannelConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<ChannelEdge>>;
};

export type ChannelEdge = {
  __typename?: "ChannelEdge";
  node: Channel;
  cursor: Scalars["String"];
};

export type DeckFilter = {
  id?: InputMaybe<Scalars["ID"]>;
  /** Case-insensitive search decks that start with the provided string */
  query?: InputMaybe<Scalars["String"]>;
  /**
   * Filter on active/inactive `Deck`s
   *
   * Note: if not specified, it is presumed you only want `Deck.isActive` == `true`
   */
  active?: InputMaybe<Scalars["Boolean"]>;
  /** Filters the Decks by the `owner` with a given `UserFilter` */
  owner?: InputMaybe<UserFilter>;
};

export type DeckConnection = {
  __typename?: "DeckConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<DeckEdge>>;
};

export type DeckEdge = {
  __typename?: "DeckEdge";
  node: Deck;
  cursor: Scalars["String"];
};

/**
 * Contains a collection of `Card` objects for a given user.
 *
 * Each Deck is specific to individual users. Decks show all unread
 * and active cards to the User and provide no further filtering.
 * Cards added to a Deck are meant to provide some sort of action
 * and should guide the User to other parts of the system or to
 * external tools.
 *
 * It is the responsibility of those adding Cards to programmatically
 * update those Cards when they are no longer relevant.
 *
 * > Note: Future versions may allow "scheduled" cards that are stored
 * for later offline use. As of this version, there is no offline support.
 */
export type Deck = Node & {
  __typename?: "Deck";
  /** ULID Representing this Deck */
  id: Scalars["ID"];
  /**
   * This appears on the dashboard above the contained cards
   *
   * > Note: Future versions may allow this behavior to be turned off.
   */
  name: Scalars["String"];
  /** User who "owns" this Deck. */
  owner: User;
  /**
   * This field determines the order in the decks appears.
   *
   * Rodio creates two decks for _most_ users within the system:
   *
   * - Team Updates (order: 100)
   * - Unread Bulletins (order: 200)
   *
   * The only items that should appear above _Team Updates_ are things that
   * require immediate attention. Evergreen content should be put in a deck
   * with an order greater than 1,000.
   *
   * Default: 1,000
   */
  order?: Maybe<Scalars["Int"]>;
  /**
   * There are two styles of decks:
   *
   * - `DeckStyle.HORIZONTAL` – displayed as a swipeable list within a list
   * - `DeckStyle.VERTIAL` - displayed as cards inline
   *
   * Horizontal cards currently only support `PreviewCard` and are not supported
   * for use outside of Rodio.
   */
  style: DeckStyle;
  /**
   * URL for viewing "all" of content that's represented in this deck.
   *
   * If present, a View All button will be presented in the header that takes
   * the user to this area. Links within Riata should be presented with the
   * `riata://` prefix.
   *
   * > Support for deep linking into an integration is coming.
   */
  url?: Maybe<Scalars["String"]>;
  /** Exposes whether a Deck is considered active. */
  isActive?: Maybe<Scalars["Boolean"]>;
  /**
   * [Relay Connection][] of `Card` objects.
   *
   * It allows for an optional `filter` parameter of `CardFilter` type in
   * addition to the standard `first`, `after` `last`, nad `before` arguments.
   *
   * [Relay Connection]: https://relay.dev/graphql/connections.htm
   */
  cards?: Maybe<CardConnection>;
};

/**
 * Contains a collection of `Card` objects for a given user.
 *
 * Each Deck is specific to individual users. Decks show all unread
 * and active cards to the User and provide no further filtering.
 * Cards added to a Deck are meant to provide some sort of action
 * and should guide the User to other parts of the system or to
 * external tools.
 *
 * It is the responsibility of those adding Cards to programmatically
 * update those Cards when they are no longer relevant.
 *
 * > Note: Future versions may allow "scheduled" cards that are stored
 * for later offline use. As of this version, there is no offline support.
 */
export type DeckCardsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CardFilter>;
};

export enum DeckStyle {
  Grid = "GRID",
  Horizontal = "HORIZONTAL",
  Vertical = "VERTICAL",
}

export type CardFilter = {
  id?: InputMaybe<Scalars["ID"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  status?: InputMaybe<CardStatus>;
  statusIn?: InputMaybe<Array<InputMaybe<CardStatus>>>;
  active?: InputMaybe<Scalars["Boolean"]>;
  query?: InputMaybe<Scalars["String"]>;
};

export enum CardStatus {
  Unread = "UNREAD",
  Read = "READ",
  Viewed = "VIEWED",
  Expired = "EXPIRED",
}

export type CardConnection = {
  __typename?: "CardConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<CardEdge>>;
};

export type CardEdge = {
  __typename?: "CardEdge";
  node: Card;
  cursor: Scalars["String"];
};

export type Card = {
  /** ULID representing this card */
  id: Scalars["ID"];
  /**
   * Name for given card.
   *
   * This is used diffferently by individual implementations of
   * `Card`. Please refer to the implementations for full documentation.
   */
  name: Scalars["String"];
  /**
   * Optional [ULID][] provided by external systems for later reference.
   *
   * [ULID]: https://github.com/ulid/spec
   */
  externalId?: Maybe<Scalars["ID"]>;
  /**
   * Automatically generated when the Card is created.
   *
   * Note: Cards cannot currently be scheduled to display in the future. As
   * such, `createdAt` is used to display time when used in the relevant `Card`
   * implementations. Future iterations may include additional `DateTime` fields
   * that allow external systems to control when a `Card` should be displayed.
   */
  createdAt: Scalars["DateTime"];
  /** Represents the READ/UNREAD status of a card. */
  status: CardStatus;
  /** Provides a reference back to the containing `Deck`. */
  inDeck: Deck;
  /** URL that tapping on this card will interact with. */
  actionURL?: Maybe<Scalars["String"]>;
  /** Value to represent order relative to other Cards in the Deck */
  order?: Maybe<Scalars["Int"]>;
};

export type EmptyDashboardLinkConnection = {
  __typename?: "EmptyDashboardLinkConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<EmptyDashboardLinkEdge>>;
};

export type EmptyDashboardLinkEdge = {
  __typename?: "EmptyDashboardLinkEdge";
  node: EmptyDashboardLink;
  cursor: Scalars["String"];
};

/** Additional links that are displayed when the dashboard is empty */
export type EmptyDashboardLink = {
  __typename?: "EmptyDashboardLink";
  id: Scalars["ID"];
  name: Scalars["String"];
  url: Scalars["String"];
  icon: CardIcon;
};

export enum CardIcon {
  /**
   * This is meant to be used with `PreviewCard` to signify that you've
   * supplied `avatarURLs` to be used in place of the generic Team icon.
   */
  Avatar = "avatar",
  Bookmark = "bookmark",
  Calendar = "calendar",
  Clock = "clock",
  Email = "email",
  Form = "form",
  Medical = "medical",
  NumberZero = "number_zero",
  NumberOne = "number_one",
  NumberTwo = "number_two",
  NumberThree = "number_three",
  NumberFour = "number_four",
  NumberFive = "number_five",
  NumberSix = "number_six",
  NumberSeven = "number_seven",
  NumberEight = "number_eight",
  NumberNine = "number_nine",
  NumberTen = "number_ten",
  NumberEleven = "number_eleven",
  NumberTwelve = "number_twelve",
  Team = "team",
  Video = "video",
  Folder = "folder",
  Internet = "internet",
  Statistics = "statistics",
  Search = "search",
  Check = "check",
  Coin = "coin",
  Cloudy = "cloudy",
  Map = "map",
  Location = "location",
  Review = "review",
  Question = "question",
  Pin = "pin",
  Tag = "tag",
  Camera = "camera",
  Image = "image",
}

export type Integration = Node & {
  __typename?: "Integration";
  id: Scalars["ID"];
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  color?: Maybe<Scalars["String"]>;
  url: Scalars["String"];
  associatedUrls?: Maybe<Array<Maybe<Scalars["String"]>>>;
  attachmentURL?: Maybe<Scalars["String"]>;
  isExternal: Scalars["Boolean"];
};

export type IntegrationFilter = {
  canHandleAttachments: Scalars["Boolean"];
};

export type IntegrationConnection = {
  __typename?: "IntegrationConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<IntegrationEdge>>;
};

export type IntegrationEdge = {
  __typename?: "IntegrationEdge";
  node: Integration;
  cursor: Scalars["String"];
};

export type GetMessagesFilter = {
  channel?: InputMaybe<Scalars["ID"]>;
  /**
   * Search for messages that contain the provided `search` value.
   *
   * Note, `Message` objects returned via a `search` are annotated with
   * the `headline`
   */
  search?: InputMaybe<Scalars["String"]>;
};

export type ReactionTypeConnection = {
  __typename?: "ReactionTypeConnection";
  pageInfo: PageInfo;
  edges: Array<Maybe<ReactionTypeEdge>>;
};

export type ReactionTypeEdge = {
  __typename?: "ReactionTypeEdge";
  node: ReactionType;
  cursor: Scalars["String"];
};

export type Health = {
  __typename?: "Health";
  status?: Maybe<Scalars["String"]>;
  djangoVersion?: Maybe<Scalars["String"]>;
  pythonVersion?: Maybe<Scalars["String"]>;
  lariatVersion?: Maybe<Scalars["String"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Dummy echo mutation to verify everything is working */
  echo?: Maybe<EchoPayload>;
  createAttachment?: Maybe<CreateAttachmentPayload>;
  createBulletin?: Maybe<CreateBulletinPayload>;
  createBulletinInbox?: Maybe<CreateBulletinInboxPayload>;
  addUserToBulletinInbox?: Maybe<AddUserToBulletinInboxPayload>;
  markBulletinAsRead?: Maybe<MarkBulletinAsReadPayload>;
  markBulletinAsViewed?: Maybe<MarkBulletinAsViewedPayload>;
  archiveBulletin?: Maybe<ArchiveBulletinPayload>;
  updateBulletin?: Maybe<UpdateBulletinPayload>;
  postDraftBulletin?: Maybe<PostDraftBulletinPayload>;
  createChannel?: Maybe<CreateChannelPayload>;
  createGroupChannel?: Maybe<CreateChannelPayload>;
  editGroupChannel?: Maybe<EditGroupChannelPayload>;
  joinChannel?: Maybe<JoinChannelPayload>;
  joinMembersInChannel?: Maybe<JoinMembersInChannelPayload>;
  leaveChannel?: Maybe<LeaveChannelPayload>;
  postMessage?: Maybe<PostMessagePayload>;
  addReaction?: Maybe<AddReactionPayload>;
  removeReaction?: Maybe<RemoveReactionPayload>;
  reportMessage?: Maybe<ReportMessagePayload>;
  markMessageRead?: Maybe<MarkMessageReadPayload>;
  markChannelAsRead?: Maybe<MarkChannelAsReadPayload>;
  archiveChannel?: Maybe<ArchiveChannelPayload>;
  unarchiveChannel?: Maybe<UnarchiveChannelPayload>;
  getOrCreateDirectMessageChannel?: Maybe<GetOrCreateDirectMessageChannelPayload>;
  muteChannel?: Maybe<MuteChannelPayload>;
  unmuteChannel?: Maybe<UnmuteChannelPayload>;
  postComment?: Maybe<PostCommentPayload>;
  createCompany?: Maybe<CreateCompanyPayload>;
  addEmployee?: Maybe<AddEmployeePayload>;
  createDeck?: Maybe<CreateDeckPayload>;
  getOrCreateDeck?: Maybe<GetOrCreateDeckPayload>;
  modifyDeck?: Maybe<ModifyDeckPayload>;
  markCardAsRead?: Maybe<MarkCardAsReadPayload>;
  markDeckAsInactive?: Maybe<MarkDeckAsInactivePayload>;
  createActionCard?: Maybe<CreateActionCardPayload>;
  createBookmarkCard?: Maybe<CreateBookmarkCardPayload>;
  createContentCard?: Maybe<CreateContentCardPayload>;
  createPreviewCard?: Maybe<CreatePreviewCardPayload>;
  modifyActionCard?: Maybe<ModifyActionCardPayload>;
  modifyBookmarkCard?: Maybe<ModifyBookmarkCardPayload>;
  /** Create a single use URL for logging in a user and redirecting them */
  createIntegrationRedirect?: Maybe<IntegrationRedirectPayload>;
  createGenericRedirect?: Maybe<GenericRedirectPayload>;
  createUser?: Maybe<CreateUserPayload>;
  /** Modify meta data for a given user */
  modifyUserMetadata?: Maybe<ModifyUserMetadataPayload>;
  changePassword?: Maybe<ChangePasswordPayload>;
  modifyUser?: Maybe<ModifyUserPayload>;
  setPushToken?: Maybe<SetPushTokenPayload>;
  offDutyAcknowledgement?: Maybe<OffDutyAcknowledgementPayload>;
  revokeTokens?: Maybe<RefreshTokenPayload>;
  /**
   * Generate an auth token and send it via SMS to the provided phone number.
   *
   * Note: This only works for phone numbers associated with users within Rodio
   * and is subject to rate limiting.
   */
  generateSMSAuthCode?: Maybe<GenerateSmsAuthCodePayload>;
  /** New authentication mutation */
  auth?: Maybe<TokenAuthPayload>;
  /** Original authentication method (deprecated, see `auth`) */
  tokenAuth?: Maybe<TokenAuthPayload>;
  verifyToken?: Maybe<VerifyTokenPayload>;
  refreshToken?: Maybe<RefreshTokenPayload>;
};

export type MutationEchoArgs = {
  input: EchoInput;
};

export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};

export type MutationCreateBulletinArgs = {
  input?: InputMaybe<CreateBulletinInput>;
};

export type MutationCreateBulletinInboxArgs = {
  input?: InputMaybe<CreateBulletinInboxInput>;
};

export type MutationAddUserToBulletinInboxArgs = {
  input?: InputMaybe<AddUserToBulletinInboxInput>;
};

export type MutationMarkBulletinAsReadArgs = {
  input?: InputMaybe<MarkBulletinAsReadInput>;
};

export type MutationMarkBulletinAsViewedArgs = {
  input?: InputMaybe<MarkBulletinAsViewedInput>;
};

export type MutationArchiveBulletinArgs = {
  input?: InputMaybe<ArchiveBulletinInput>;
};

export type MutationUpdateBulletinArgs = {
  input?: InputMaybe<UpdateBulletinInput>;
};

export type MutationPostDraftBulletinArgs = {
  input?: InputMaybe<PostDraftBulletinInput>;
};

export type MutationCreateChannelArgs = {
  input: CreateChannelMutationInput;
};

export type MutationCreateGroupChannelArgs = {
  input: CreateGroupChannelMutationInput;
};

export type MutationEditGroupChannelArgs = {
  input: EditGroupChannelInput;
};

export type MutationJoinChannelArgs = {
  input: JoinChannelInput;
};

export type MutationJoinMembersInChannelArgs = {
  input: JoinMembersInChannelInput;
};

export type MutationLeaveChannelArgs = {
  input: LeaveChannelInput;
};

export type MutationPostMessageArgs = {
  input: PostMessageInput;
};

export type MutationAddReactionArgs = {
  input: AddReactionInput;
};

export type MutationRemoveReactionArgs = {
  input: RemoveReactionInput;
};

export type MutationReportMessageArgs = {
  input: ReportMessageInput;
};

export type MutationMarkMessageReadArgs = {
  input: MarkMessageReadInput;
};

export type MutationMarkChannelAsReadArgs = {
  input: MarkChannelAsReadInput;
};

export type MutationArchiveChannelArgs = {
  input: ArchiveChannelInput;
};

export type MutationUnarchiveChannelArgs = {
  input: UnarchiveChannelInput;
};

export type MutationGetOrCreateDirectMessageChannelArgs = {
  input: GetOrCreateDirectMessageChannelInput;
};

export type MutationMuteChannelArgs = {
  input: MuteChannelInput;
};

export type MutationUnmuteChannelArgs = {
  input: UnmuteChannelInput;
};

export type MutationPostCommentArgs = {
  input: PostCommentInput;
};

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};

export type MutationAddEmployeeArgs = {
  input: AddEmployeeInput;
};

export type MutationCreateDeckArgs = {
  input?: InputMaybe<CreateDeckInput>;
};

export type MutationGetOrCreateDeckArgs = {
  input?: InputMaybe<GetOrCreateDeckInput>;
};

export type MutationModifyDeckArgs = {
  input?: InputMaybe<ModifyDeckInput>;
};

export type MutationMarkCardAsReadArgs = {
  input?: InputMaybe<MarkCardAsReadInput>;
};

export type MutationMarkDeckAsInactiveArgs = {
  input?: InputMaybe<MarkDeckAsInactiveInput>;
};

export type MutationCreateActionCardArgs = {
  input?: InputMaybe<CreateActionCardInput>;
};

export type MutationCreateBookmarkCardArgs = {
  input?: InputMaybe<CreateBookmarkCardInput>;
};

export type MutationCreateContentCardArgs = {
  input?: InputMaybe<CreateContentCardInput>;
};

export type MutationCreatePreviewCardArgs = {
  input?: InputMaybe<CreatePreviewCardInput>;
};

export type MutationModifyActionCardArgs = {
  filter?: InputMaybe<ActionCardFilter>;
  input?: InputMaybe<ModifyActionCardInput>;
};

export type MutationModifyBookmarkCardArgs = {
  filter?: InputMaybe<BookmarkCardFilter>;
  input?: InputMaybe<ModifyBookmarkCardInput>;
};

export type MutationCreateIntegrationRedirectArgs = {
  input: IntegrationRedirectInput;
};

export type MutationCreateGenericRedirectArgs = {
  input: GenericRedirectInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationModifyUserMetadataArgs = {
  input: ModifyUserMetadataInput;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationModifyUserArgs = {
  input: ModifyUserInput;
  avatar?: InputMaybe<Scalars["Upload"]>;
};

export type MutationSetPushTokenArgs = {
  input: SetPushTokenInput;
};

export type MutationOffDutyAcknowledgementArgs = {
  input: OffDutyAcknowledgementInput;
};

export type MutationRevokeTokensArgs = {
  input: RevokeTokensInput;
};

export type MutationGenerateSmsAuthCodeArgs = {
  phone: Scalars["String"];
};

export type MutationAuthArgs = {
  input?: InputMaybe<AuthInput>;
};

export type MutationTokenAuthArgs = {
  company: Scalars["String"];
  username: Scalars["String"];
  password: Scalars["String"];
};

export type MutationVerifyTokenArgs = {
  token: Scalars["String"];
};

export type MutationRefreshTokenArgs = {
  token: Scalars["String"];
  refreshToken: Scalars["String"];
};

export type EchoInput = {
  msg: Scalars["String"];
};

export type EchoPayload = {
  __typename?: "EchoPayload";
  msg: Scalars["String"];
};

export type CreateAttachmentInput = {
  id?: InputMaybe<Scalars["ID"]>;
  contentType: ContentType;
  integration?: InputMaybe<IntegrationAttachmentInput>;
  dimensions?: InputMaybe<DimensionInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export enum ContentType {
  Doc = "DOC",
  Docx = "DOCX",
  Ppt = "PPT",
  Pptx = "PPTX",
  Xls = "XLS",
  Xlsx = "XLSX",
  Pdf = "PDF",
  ImageGif = "IMAGE_GIF",
  ImagePng = "IMAGE_PNG",
  ImageJpg = "IMAGE_JPG",
  Integration = "INTEGRATION",
}

export type IntegrationAttachmentInput = {
  integration: Scalars["ID"];
  url: Scalars["String"];
};

export type DimensionInput = {
  width?: InputMaybe<Scalars["Int"]>;
  height?: InputMaybe<Scalars["Int"]>;
};

export type CreateAttachmentPayload = {
  __typename?: "CreateAttachmentPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  attachment?: Maybe<CreatedAttachment>;
};

export type ErrorType = {
  __typename?: "ErrorType";
  field: Scalars["String"];
  messages: Array<Scalars["String"]>;
};

/**
 * CreatedAttachment is a union of the various attachments
 * that can be created via `createAttachment` mutation.
 */
export type CreatedAttachment =
  | ImageAttachment
  | OfficeAttachment
  | PdfAttachment
  | IntegrationAttachment;

export type ImageAttachment = Attachment &
  Uploadable &
  Node & {
    __typename?: "ImageAttachment";
    id: Scalars["ID"];
    url: Scalars["String"];
    dimensions?: Maybe<Dimension>;
    /** Signed URL to allow uploading content for this attachment */
    uploadUrl?: Maybe<Scalars["String"]>;
    contentType: Scalars["String"];
  };

export type Uploadable = {
  /** Signed URL to allow uploading content for this attachment */
  uploadUrl?: Maybe<Scalars["String"]>;
};

export type Dimension = {
  __typename?: "Dimension";
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
};

export type OfficeAttachment = Attachment &
  Uploadable &
  Node & {
    __typename?: "OfficeAttachment";
    id: Scalars["ID"];
    url: Scalars["String"];
    uploadUrl?: Maybe<Scalars["String"]>;
    contentType: Scalars["String"];
  };

export type PdfAttachment = Attachment &
  Uploadable &
  Node & {
    __typename?: "PDFAttachment";
    id: Scalars["ID"];
    url: Scalars["String"];
    uploadUrl?: Maybe<Scalars["String"]>;
  };

export type IntegrationAttachment = Attachment &
  Node & {
    __typename?: "IntegrationAttachment";
    id: Scalars["ID"];
    integration: Integration;
    url: Scalars["String"];
  };

export type CreateBulletinInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  expires?: InputMaybe<Scalars["DateTime"]>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  isPriority?: InputMaybe<Scalars["Boolean"]>;
  isRequired?: InputMaybe<Scalars["Boolean"]>;
  allowComments?: InputMaybe<Scalars["Boolean"]>;
  allowVisibility?: InputMaybe<Scalars["Boolean"]>;
  scheduledAt?: InputMaybe<Scalars["DateTime"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]>;
  /** `adminVisible` is a no-op field that's added for backward compatibility */
  adminVisible?: InputMaybe<Scalars["Boolean"]>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
};

export type CreateBulletinPayload = {
  __typename?: "CreateBulletinPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type CreateBulletinInboxInput = {
  name: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateBulletinInboxPayload = {
  __typename?: "CreateBulletinInboxPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  inbox?: Maybe<BulletinInbox>;
};

export type AddUserToBulletinInboxInput = {
  inbox: Scalars["ID"];
  user: Scalars["ID"];
};

export type AddUserToBulletinInboxPayload = {
  __typename?: "AddUserToBulletinInboxPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["Boolean"]>;
};

export type MarkBulletinAsReadInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MarkBulletinAsReadPayload = {
  __typename?: "MarkBulletinAsReadPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type MarkBulletinAsViewedInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MarkBulletinAsViewedPayload = {
  __typename?: "MarkBulletinAsViewedPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type ArchiveBulletinInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type ArchiveBulletinPayload = {
  __typename?: "ArchiveBulletinPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type UpdateBulletinInput = {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  expires?: InputMaybe<Scalars["DateTime"]>;
  isPriority?: InputMaybe<Scalars["Boolean"]>;
  isRequired?: InputMaybe<Scalars["Boolean"]>;
  allowComments?: InputMaybe<Scalars["Boolean"]>;
  allowVisibility?: InputMaybe<Scalars["Boolean"]>;
  scheduledAt?: InputMaybe<Scalars["DateTime"]>;
  recipientInboxes?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
};

export type UpdateBulletinPayload = {
  __typename?: "UpdateBulletinPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type PostDraftBulletinInput = {
  id: Scalars["ID"];
};

export type PostDraftBulletinPayload = {
  __typename?: "PostDraftBulletinPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  bulletin?: Maybe<Bulletin>;
};

export type CreateChannelMutationInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  slug: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateChannelPayload = {
  __typename?: "CreateChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
};

export type CreateGroupChannelMutationInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  members: Array<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type EditGroupChannelInput = {
  channel: Scalars["ID"];
  name: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type EditGroupChannelPayload = {
  __typename?: "EditGroupChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
};

export type JoinChannelInput = {
  channel: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type JoinChannelPayload = {
  __typename?: "JoinChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
};

export type JoinMembersInChannelInput = {
  channel: Scalars["ID"];
  members: Array<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type JoinMembersInChannelPayload = {
  __typename?: "JoinMembersInChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type LeaveChannelInput = {
  channel: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type LeaveChannelPayload = {
  __typename?: "LeaveChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type PostMessageInput = {
  id?: InputMaybe<Scalars["ID"]>;
  content: Scalars["String"];
  channel: Scalars["ID"];
  attachments?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type PostMessagePayload = {
  __typename?: "PostMessagePayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  message?: Maybe<Message>;
};

export type AddReactionInput = {
  id: Scalars["ID"];
  reaction: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type AddReactionPayload = {
  __typename?: "AddReactionPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  reaction?: Maybe<Reaction>;
  message?: Maybe<Message>;
};

export type RemoveReactionInput = {
  id: Scalars["ID"];
  reaction: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type RemoveReactionPayload = {
  __typename?: "RemoveReactionPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  reaction?: Maybe<Reaction>;
  message?: Maybe<Message>;
};

export type ReportMessageInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type ReportMessagePayload = {
  __typename?: "ReportMessagePayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type MarkMessageReadInput = {
  id?: InputMaybe<Scalars["ID"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
};

export type MarkMessageReadPayload = {
  __typename?: "MarkMessageReadPayload";
  id?: Maybe<Scalars["ID"]>;
  success?: Maybe<Scalars["Boolean"]>;
  ids?: Maybe<Array<Maybe<MarkMessageReadPayload>>>;
};

export type MarkChannelAsReadInput = {
  id?: InputMaybe<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MarkChannelAsReadPayload = {
  __typename?: "MarkChannelAsReadPayload";
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type ArchiveChannelInput = {
  id?: InputMaybe<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type ArchiveChannelPayload = {
  __typename?: "ArchiveChannelPayload";
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type UnarchiveChannelInput = {
  id?: InputMaybe<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type UnarchiveChannelPayload = {
  __typename?: "UnarchiveChannelPayload";
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type GetOrCreateDirectMessageChannelInput = {
  recipients: Array<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type GetOrCreateDirectMessageChannelPayload = {
  __typename?: "GetOrCreateDirectMessageChannelPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
};

export type MuteChannelInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MuteChannelPayload = {
  __typename?: "MuteChannelPayload";
  error?: Maybe<Scalars["String"]>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type UnmuteChannelInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type UnmuteChannelPayload = {
  __typename?: "UnmuteChannelPayload";
  error?: Maybe<Scalars["String"]>;
  clientMutationId?: Maybe<Scalars["String"]>;
  channel?: Maybe<Channel>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type PostCommentInput = {
  id?: InputMaybe<Scalars["ID"]>;
  content: Scalars["String"];
  repliesTo: RepliesToInput;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type RepliesToInput = {
  type: CommentableNode;
  id: Scalars["ID"];
};

export enum CommentableNode {
  Bulletin = "Bulletin",
}

export type PostCommentPayload = {
  __typename?: "PostCommentPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  comment?: Maybe<Comment>;
};

export type CreateCompanyInput = {
  id?: InputMaybe<Scalars["ID"]>;
  slug?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  logoUrl?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateCompanyPayload = {
  __typename?: "CreateCompanyPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  company?: Maybe<Company>;
};

export type AddEmployeeInput = {
  company: Scalars["ID"];
  employee: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type AddEmployeePayload = {
  __typename?: "AddEmployeePayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type CreateDeckInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  owner: Scalars["ID"];
  externalId?: InputMaybe<Scalars["ID"]>;
  order?: InputMaybe<Scalars["Int"]>;
  style: DeckStyle;
  url?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateDeckPayload = {
  __typename?: "CreateDeckPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  deck: Deck;
};

export type GetOrCreateDeckInput = {
  /**
   * Optional ID of the deck you want to retrieve or create
   *
   * Note, this allows you to specify a ULID for a given Deck, but does
   * change the semantics. When an ID is provided, the normal name, owner,
   * company trio are ignored when attempting to fetch data.
   */
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  owner: Scalars["ID"];
  order?: InputMaybe<Scalars["Int"]>;
  style: DeckStyle;
  url?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type GetOrCreateDeckPayload = {
  __typename?: "GetOrCreateDeckPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  deck: Deck;
  created: Scalars["Boolean"];
};

export type ModifyDeckInput = {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["Int"]>;
  style?: InputMaybe<DeckStyle>;
  url?: InputMaybe<Scalars["String"]>;
  isActive?: InputMaybe<Scalars["Boolean"]>;
};

export type ModifyDeckPayload = {
  __typename?: "ModifyDeckPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  deck?: Maybe<Deck>;
};

export type MarkCardAsReadInput = {
  card?: InputMaybe<Scalars["ID"]>;
  externalId?: InputMaybe<Scalars["ID"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MarkCardAsReadPayload = {
  __typename?: "MarkCardAsReadPayload";
  card: Card;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type MarkDeckAsInactiveInput = {
  id: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MarkDeckAsInactivePayload = {
  __typename?: "MarkDeckAsInactivePayload";
  deck?: Maybe<Deck>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateActionCardInput = {
  id?: InputMaybe<Scalars["ID"]>;
  externalId?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  status?: InputMaybe<CardStatus>;
  inDeck: Scalars["ID"];
  actionURL?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<ActionCardStyle>;
};

export enum ActionCardStyle {
  Default = "DEFAULT",
  Success = "SUCCESS",
  Warning = "WARNING",
  Danger = "DANGER",
  Info = "INFO",
}

export type CreateActionCardPayload = {
  __typename?: "CreateActionCardPayload";
  card?: Maybe<ActionCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * `ActionCards` represent a button requiring an action within Rodio.
 *
 * These should be used when the User has one action they can take based on
 * this card. Some examples include:
 *
 * - Punching in to a shift
 * - Filling out an overdue form
 *
 * These cards should be dismissed once they have been processed and _should_
 * only show up when a User has an action they need to take. These cards
 * _should not_ be used for bookmarks.
 */
export type ActionCard = Card &
  Node & {
    __typename?: "ActionCard";
    /**
     * ULID representing this `ActionCard`.
     *
     * This will be auto-generated by Corral when created.
     */
    id: Scalars["ID"];
    /** ULID representing some external source this card references */
    externalId?: Maybe<Scalars["ID"]>;
    /** This is displayed as the button text. */
    name: Scalars["String"];
    /** Not used when displaying `ActionCards` */
    createdAt: Scalars["DateTime"];
    status: CardStatus;
    inDeck: Deck;
    /** Location to send User when tapping on the `ActionCard` */
    actionURL?: Maybe<Scalars["String"]>;
    /** Determines the style of ActionCard to display */
    style?: Maybe<ActionCardStyle>;
    order?: Maybe<Scalars["Int"]>;
  };

export type CreateBookmarkCardInput = {
  id?: InputMaybe<Scalars["ID"]>;
  externalId?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  content?: InputMaybe<Scalars["String"]>;
  actionURL?: InputMaybe<Scalars["String"]>;
  icon?: InputMaybe<CardIcon>;
  status?: InputMaybe<CardStatus>;
  inDeck: Scalars["ID"];
  isExternal?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateBookmarkCardPayload = {
  __typename?: "CreateBookmarkCardPayload";
  card?: Maybe<BookmarkCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type BookmarkCard = Card &
  Node & {
    __typename?: "BookmarkCard";
    id: Scalars["ID"];
    externalId?: Maybe<Scalars["ID"]>;
    name: Scalars["String"];
    content?: Maybe<Scalars["String"]>;
    actionURL?: Maybe<Scalars["String"]>;
    icon?: Maybe<CardIcon>;
    createdAt: Scalars["DateTime"];
    status: CardStatus;
    inDeck: Deck;
    order?: Maybe<Scalars["Int"]>;
    /**
     * Indicates when the card should be opened in an external browser, rather than
     * being opened in a WebView within the FieldConnector app.
     */
    isExternal?: Maybe<Scalars["Boolean"]>;
  };

export type CreateContentCardInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  body: Scalars["String"];
  creator?: InputMaybe<Scalars["ID"]>;
  actionURL?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<CardStatus>;
  inDeck: Scalars["ID"];
};

export type CreateContentCardPayload = {
  __typename?: "CreateContentCardPayload";
  card?: Maybe<ContentCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * `ContentCard` represent brief content that is displayed on the Dashboard.
 *
 * The canonical example of this within Rodio are `Bulletins`.
 *
 * - #TODO: Image of rendered ContentCard
 */
export type ContentCard = Card &
  Node & {
    __typename?: "ContentCard";
    id: Scalars["ID"];
    externalId?: Maybe<Scalars["ID"]>;
    /** Displays as the title of a `ContentCard` when rendered. */
    name: Scalars["String"];
    createdAt: Scalars["DateTime"];
    /**
     * Displayed as the body of the `ContentCard`.
     *
     * This is processed as [Markdown][] using our `PreviewMarkdown` component.
     * This turns all headers into plain text and may make other adjustments to
     * the output in order to allow proper "preview" display. Given constraints
     * of the display of `ContentCards`, this might be truncated.
     *
     * [Markdown]: https://daringfireball.net/projects/markdown/syntax
     */
    body?: Maybe<Scalars["String"]>;
    /**
     * The "user" (bot or human) that created this card.
     *
     * It is used to display the name and avatar of the user when displaying a
     * `ContentCard` to the recipient.
     */
    creator?: Maybe<User>;
    /** Additional information used in the display below the creator's name */
    footerExtra?: Maybe<Scalars["String"]>;
    actionURL?: Maybe<Scalars["String"]>;
    status: CardStatus;
    inDeck: Deck;
    order?: Maybe<Scalars["Int"]>;
    hashtags?: Maybe<HashtagConnection>;
  };

/**
 * `ContentCard` represent brief content that is displayed on the Dashboard.
 *
 * The canonical example of this within Rodio are `Bulletins`.
 *
 * - #TODO: Image of rendered ContentCard
 */
export type ContentCardHashtagsArgs = {
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HashtagFilters>;
};

export type CreatePreviewCardInput = {
  id?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  body: Scalars["String"];
  icon?: InputMaybe<CardIcon>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  status?: InputMaybe<CardStatus>;
  inDeck: Scalars["ID"];
  actionURL?: InputMaybe<Scalars["String"]>;
};

export type CreatePreviewCardPayload = {
  __typename?: "CreatePreviewCardPayload";
  card?: Maybe<PreviewCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * `PreviewCard` for displaying a quick preview
 *
 * This is meant to be used with a `Deck` set to `DeckStyle.HORIZONTAL`.
 *
 * > Note: This card is specific to Rodio internals and should not be used by external
 * > systems. It's documented here for thoroughness.
 */
export type PreviewCard = Card &
  Node & {
    __typename?: "PreviewCard";
    id: Scalars["ID"];
    externalId?: Maybe<Scalars["ID"]>;
    /** Displayed as the top text element on `PreviewCard` */
    name: Scalars["String"];
    /** Displayed as the sub-header on the `PreviewCard` */
    body?: Maybe<Scalars["String"]>;
    /**
     * Determines type of avatar that is displayed
     *
     * - `PreviewCardIcon.TEAM` - this uses the default `ChannelAvatar` in Riata
     *   for the `externalId`.
     * - `PreviewCardIcon.AVATAR` - this uses the avatar(s) set in `avatarURLs` to
     *   display specific avatars.
     */
    icon?: Maybe<PreviewCardIcon>;
    createdAt: Scalars["DateTime"];
    status: CardStatus;
    inDeck: Deck;
    actionURL?: Maybe<Scalars["String"]>;
    /**
     * Contains the URLs for avatars to displays as part of the `PreviewCard`.
     *
     * This should be used in conjunction with `icon` set to `PreviewCardIcon.AVATAR`.
     *
     * The number of avatars changes the display:
     *
     * - One `PreviewCardAvatarURL` is a singular avatar
     * - Two or more `PreviewCardAvatarURLs` displays a multi-user icon. Currently only
     *   the first two avatars are displayed.
     */
    avatarURLs?: Maybe<Array<Maybe<PreviewCardAvatarUrl>>>;
    order?: Maybe<Scalars["Int"]>;
  };

export enum PreviewCardIcon {
  Team = "TEAM",
  Avatar = "AVATAR",
}

export type PreviewCardAvatarUrl = Node & {
  __typename?: "PreviewCardAvatarURL";
  id: Scalars["ID"];
  url: Scalars["String"];
};

export type ActionCardFilter = {
  id?: InputMaybe<Scalars["ID"]>;
  externalId?: InputMaybe<Scalars["ID"]>;
};

export type ModifyActionCardInput = {
  externalId?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<CardStatus>;
  inDeck?: InputMaybe<Scalars["ID"]>;
  actionURL?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<ActionCardStyle>;
};

export type ModifyActionCardPayload = {
  __typename?: "ModifyActionCardPayload";
  card?: Maybe<ActionCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type BookmarkCardFilter = {
  id?: InputMaybe<Scalars["ID"]>;
  externalId?: InputMaybe<Scalars["ID"]>;
};

export type ModifyBookmarkCardInput = {
  externalId?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  actionURL?: InputMaybe<Scalars["String"]>;
  icon?: InputMaybe<CardIcon>;
  status?: InputMaybe<CardStatus>;
  inDeck?: InputMaybe<Scalars["ID"]>;
  isExternal?: InputMaybe<Scalars["Boolean"]>;
};

export type ModifyBookmarkCardPayload = {
  __typename?: "ModifyBookmarkCardPayload";
  card?: Maybe<BookmarkCard>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type IntegrationRedirectInput = {
  integration: Scalars["ID"];
  destination?: InputMaybe<Scalars["String"]>;
};

export type IntegrationRedirectPayload = {
  __typename?: "IntegrationRedirectPayload";
  integration: Scalars["ID"];
  url?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type GenericRedirectInput = {
  destination: Scalars["String"];
};

export type GenericRedirectPayload = {
  __typename?: "GenericRedirectPayload";
  url?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateUserInput = {
  id?: InputMaybe<Scalars["ID"]>;
  username: Scalars["String"];
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateUserPayload = {
  __typename?: "CreateUserPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type ModifyUserMetadataInput = {
  id: Scalars["ID"];
  /** Key */
  key: Scalars["String"];
  /** Stringified JSON value */
  value: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type ModifyUserMetadataPayload = {
  __typename?: "ModifyUserMetadataPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  user?: Maybe<User>;
};

export type ChangePasswordInput = {
  old: Scalars["String"];
  new: Scalars["String"];
};

export type ChangePasswordPayload = {
  __typename?: "ChangePasswordPayload";
  success: Scalars["Boolean"];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type ModifyUserInput = {
  id: Scalars["ID"];
  username?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  avatar?: InputMaybe<Scalars["Upload"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  jobTitle?: InputMaybe<Scalars["String"]>;
};

export type ModifyUserPayload = {
  __typename?: "ModifyUserPayload";
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type SetPushTokenInput = {
  deviceId: Scalars["String"];
  value: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type SetPushTokenPayload = {
  __typename?: "SetPushTokenPayload";
  pushToken: PushToken;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type OffDutyAcknowledgementInput = {
  id: Scalars["ID"];
  extendedHours: Scalars["Int"];
};

export type OffDutyAcknowledgementPayload = {
  __typename?: "OffDutyAcknowledgementPayload";
  extendedHours?: Maybe<Scalars["Int"]>;
  acknowledgedTime?: Maybe<Scalars["String"]>;
  extendNotifications?: Maybe<Scalars["Boolean"]>;
  success: Scalars["Boolean"];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type RevokeTokensInput = {
  token?: InputMaybe<Scalars["String"]>;
};

export type RefreshTokenPayload = {
  __typename?: "RefreshTokenPayload";
  token?: Maybe<Scalars["String"]>;
  payload?: Maybe<Scalars["String"]>;
};

export type GenerateSmsAuthCodePayload = {
  __typename?: "GenerateSMSAuthCodePayload";
  success: Scalars["Boolean"];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type AuthInput = {
  username?: InputMaybe<UsernameAuthInput>;
  phone?: InputMaybe<PhoneAuthInput>;
  bearer?: InputMaybe<Scalars["String"]>;
};

export type UsernameAuthInput = {
  username: Scalars["String"];
  password: Scalars["String"];
};

export type PhoneAuthInput = {
  /** Phone number associated with a User */
  phone: Scalars["String"];
  /** Six-digit number generated by `generateSMSAuthCode` mutation */
  smsCode: Scalars["String"];
};

export type TokenAuthPayload = {
  __typename?: "TokenAuthPayload";
  token?: Maybe<Scalars["String"]>;
  refreshToken?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type VerifyTokenPayload = {
  __typename?: "VerifyTokenPayload";
  valid?: Maybe<Scalars["String"]>;
  user?: Maybe<Scalars["String"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  counter: Scalars["Int"];
  onEvent?: Maybe<EventPayload>;
  onNewBulletin?: Maybe<Bulletin>;
  onNewMessage?: Maybe<Message>;
  onEditUser?: Maybe<UserEditPayload>;
};

export type SubscriptionOnEventArgs = {
  token: Scalars["String"];
};

export type SubscriptionOnNewBulletinArgs = {
  token: Scalars["String"];
};

export type SubscriptionOnNewMessageArgs = {
  channel: Scalars["ID"];
  token: Scalars["String"];
};

export type SubscriptionOnEditUserArgs = {
  user: Scalars["ID"];
  token: Scalars["String"];
};

export type EventPayload = {
  __typename?: "EventPayload";
  node: Node;
};

export type UserEditPayload = {
  __typename?: "UserEditPayload";
  id?: Maybe<Scalars["ID"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  offDuty?: Maybe<Scalars["Boolean"]>;
  company?: Maybe<Company>;
};

export type CreateCardInput = {
  actionCard?: InputMaybe<CreateActionCardInput>;
  contentCard?: InputMaybe<CreateContentCardInput>;
  previewCard?: InputMaybe<CreatePreviewCardInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CreateCardPayload = {
  __typename?: "CreateCardPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  card?: Maybe<Card>;
};

export enum EventType {
  New = "NEW",
  Save = "SAVE",
  OnDuty = "ON_DUTY",
  OffDuty_10Min = "OFF_DUTY_10_MIN",
  OffDuty_1Min = "OFF_DUTY_1_MIN",
  OffDuty = "OFF_DUTY",
}

export type HashtagStats = Node & {
  __typename?: "HashtagStats";
  id: Scalars["ID"];
  node: Node;
  number: Scalars["Int"];
};

export type Notification = Node & {
  __typename?: "Notification";
  id: Scalars["ID"];
  message: Scalars["String"];
};

export type RevokeTokensPayload = {
  __typename?: "RevokeTokensPayload";
  success: Scalars["Boolean"];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type TwitterAttachment = Attachment &
  Node & {
    __typename?: "TwitterAttachment";
    id: Scalars["ID"];
    url: Scalars["String"];
    content: Scalars["String"];
  };

export type UnreadMessageFilter = {
  channel?: InputMaybe<Scalars["ID"]>;
};
